import { connect } from "react-redux"

function Connect(){
    return(
        <div>
            Connect
        </div>
    )
}

const mapStateToProps = state => ({

})

export default connect(mapStateToProps,{

})(Connect)